export default __webpack_public_path__ + "static/media/rightIcon.a16d924f.svg";